import Link from "next/link"
import { formatDateString } from '@/utils/index'
import Text from "@/components/atoms/Text/text"
import { HeadingText } from "@/components/atoms/HeadingText/heading-text"
import UserInfo from "../UserInfo"
import Rating from "../Rating/rating"

export const ProfileCard = ({ profile, translations }: { profile: any, translations: Record<string, any> }) => {
  // Safely extract data with default values
  const firstName = profile?.user?.firstName ?? translations.consultants.card.unknown
  const lastName = profile?.user?.lastName ?? ""
  const name = `${firstName} ${lastName}`.trim() // Ensure no extra spaces if lastName is missing
  const href = `/consultant/${profile?.id}`
  const linkAria = `Visit consultant: ${name}`
  const professionName = profile?.profession?.name ?? translations.consultants.card.unknownProfession
  const avatarUrl = profile?.user?.avatar
  const averageRating = profile?.averageRating ?? 0 // Default to 0 if missing
  const location = profile.user.location?.city || profile.user.location?.state || profile.user.location?.country || "Location not specified"
  const createdAt = profile?.createdAt ? formatDateString(profile.createdAt) : translations.consultants.card.notSpecified
  const updatedAt = profile?.reviews?.length ? formatDateString(profile.reviews[0].createdAt) : translations.consultants.card.noReviews

  return (
    <Link
      aria-label={linkAria}
      href={href}
      className="max-w-xs space-y-4 rounded-lg border bg-white p-6 shadow-lg hover:shadow-2xl dark:border-gray-800 dark:bg-black dark:hover:shadow-2xl"
    >
      {/* User Info Section */}
      <UserInfo name={name} roles={professionName} imageUrl={avatarUrl} />

      {/* Rating Section */}
      <div className="flex items-center justify-center space-x-2">
        <Rating stars={averageRating} />
        <p className="font-semibold text-black">{averageRating}</p>
      </div>

      {/* Info Section */}
      <div className="space-y-1 font-serif">
        <div className="flex justify-between justify-self-auto py-2">
          <Text>{translations.consultants.card.from}</Text>
          <HeadingText level={4} className="font-semibold">
            {location}
          </HeadingText>
        </div>
        <div className="flex justify-between justify-self-auto py-2">
          <Text>{translations.consultants.card.memberSince}</Text>
          <HeadingText level={4} className="font-semibold">
            {createdAt}
          </HeadingText>
        </div>
        <div className="flex justify-between justify-self-auto py-2">
          <Text>{translations.consultants.card.reviews}</Text>
          <HeadingText level={4} className="font-semibold">
            {updatedAt}
          </HeadingText>
        </div>
      </div>
    </Link>
  )
}
